import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { ApplicationRejectionRequest } from '../../types/applications'
import api from '../../api'

const useRejectApplication = (applicationID: string) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (applicationRejection: ApplicationRejectionRequest) => {
			return api.applications.rejectApplication(applicationRejection)
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['applications'] })
			queryClient.invalidateQueries({
				queryKey: ['applications', applicationID]
			})
		}
	})
}

export default useRejectApplication
